// Maarivil app-wide test IDs
export const NAV = {
  logo: 'nav-logo',
  home: 'nav-home-link',
  artists: 'nav-artists-link',
  events: 'nav-events-link',
  castings: 'nav-castings-link',
  onboarding: 'nav-onboarding-link',
  dashboard: 'nav-dashboard-link',
  admin: 'nav-admin-link',
  login: 'nav-login-button',
  register: 'nav-register-button',
  logout: 'nav-logout-button',
  avatar: 'nav-avatar',
  menu: 'nav-mobile-menu-toggle',
};

export const HERO = {
  searchInput: 'hero-ai-search-input',
  searchButton: 'hero-ai-search-button',
  ctaArtists: 'hero-cta-browse-artists',
  ctaJoin: 'hero-cta-join-artist',
};

export const ARTIST_CARD = {
  root: 'artist-card',
  bookButton: 'artist-card-book-button',
};

export const ARTIST_DETAIL = {
  root: 'artist-detail',
  bookButton: 'artist-detail-book-button',
  reviewSubmit: 'artist-detail-review-submit',
  reviewInput: 'artist-detail-review-input',
  ratingSelect: 'artist-detail-rating-select',
};

export const BOOKING = {
  modal: 'booking-modal',
  eventTypeInput: 'booking-event-type-input',
  eventDateInput: 'booking-event-date-input',
  locationInput: 'booking-location-input',
  budgetInput: 'booking-budget-input',
  messageInput: 'booking-message-input',
  emailInput: 'booking-email-input',
  phoneInput: 'booking-phone-input',
  submitButton: 'booking-submit-button',
  closeButton: 'booking-close-button',
};

export const ONBOARDING = {
  stageNameInput: 'onboarding-stage-name-input',
  bioInput: 'onboarding-bio-input',
  categoriesInput: 'onboarding-categories-input',
  skillsInput: 'onboarding-skills-input',
  languagesInput: 'onboarding-languages-input',
  cityInput: 'onboarding-city-input',
  countryInput: 'onboarding-country-input',
  experienceInput: 'onboarding-experience-input',
  priceMinInput: 'onboarding-price-min-input',
  priceMaxInput: 'onboarding-price-max-input',
  profileImageInput: 'onboarding-profile-image-input',
  coverImageInput: 'onboarding-cover-image-input',
  instagramInput: 'onboarding-instagram-input',
  youtubeInput: 'onboarding-youtube-input',
  embedInput: 'onboarding-embed-input',
  aiGenerateButton: 'onboarding-ai-generate-button',
  saveButton: 'onboarding-save-button',
  aiNotesInput: 'onboarding-ai-notes-input',
};

export const EVENTS = {
  card: 'event-card',
  detailRoot: 'event-detail',
  createTitle: 'event-create-title-input',
};

export const CASTING = {
  card: 'casting-card',
  applyButton: 'casting-apply-button',
  applyMessage: 'casting-apply-message-input',
  applyVideo: 'casting-apply-video-input',
  applySubmit: 'casting-apply-submit-button',
};

export const ADMIN = {
  root: 'admin-dashboard',
  verifyButton: 'admin-verify-button',
};

export const AUTH = {
  googleButton: 'auth-google-button',
  accountTypeArtist: 'register-account-type-artist',
  accountTypeOrganizer: 'register-account-type-organizer',
  accountTypeCasting: 'register-account-type-casting',
  accountTypeFan: 'register-account-type-fan',
};

export const POST_CASTING = {
  titleInput: 'post-casting-title-input',
  descriptionInput: 'post-casting-description-input',
  roleTypeInput: 'post-casting-role-type-input',
  locationInput: 'post-casting-location-input',
  deadlineInput: 'post-casting-deadline-input',
  budgetInput: 'post-casting-budget-input',
  requirementsInput: 'post-casting-requirements-input',
  submitButton: 'post-casting-submit-button',
};

export const POST_EVENT = {
  titleInput: 'post-event-title-input',
  descriptionInput: 'post-event-description-input',
  categoryInput: 'post-event-category-input',
  cityInput: 'post-event-city-input',
  venueInput: 'post-event-venue-input',
  dateInput: 'post-event-date-input',
  priceInput: 'post-event-price-input',
  coverInput: 'post-event-cover-input',
  submitButton: 'post-event-submit-button',
};

export const KYC = {
  fullNameInput: 'kyc-full-name-input',
  docTypeSelect: 'kyc-document-type-select',
  docNumberInput: 'kyc-document-number-input',
  docUploadInput: 'kyc-document-upload-input',
  selfieUploadInput: 'kyc-selfie-upload-input',
  submitButton: 'kyc-submit-button',
};

export const PRICING = {
  planBasic: 'pricing-plan-basic',
  planProfessional: 'pricing-plan-professional',
  planElite: 'pricing-plan-elite',
  subscribeBasic: 'pricing-subscribe-basic',
  subscribeProfessional: 'pricing-subscribe-professional',
  subscribeElite: 'pricing-subscribe-elite',
};

export const TICKETS = {
  buyButton: 'tickets-buy-button',
  quantityInput: 'tickets-quantity-input',
  checkoutButton: 'tickets-checkout-button',
};

export const AI_MANAGER = {
  chatToggle: 'ai-manager-toggle',
  chatInput: 'ai-manager-input',
  sendButton: 'ai-manager-send-button',
  closeButton: 'ai-manager-close-button',
};

export const INVITE = {
  root: 'invite-page',
  linkDisplay: 'invite-link-display',
  copyButton: 'invite-copy-button',
  shareNative: 'invite-share-native-button',
  shareWhatsapp: 'invite-share-whatsapp-button',
  shareTwitter: 'invite-share-twitter-button',
  shareLinkedin: 'invite-share-linkedin-button',
  shareFacebook: 'invite-share-facebook-button',
  shareTelegram: 'invite-share-telegram-button',
  shareEmail: 'invite-share-email-button',
  totalSignups: 'invite-total-signups',
  referralsList: 'invite-referrals-list',
  filterBar: 'invite-filter-bar',
  filterChip: 'invite-filter-chip',
  emptyFilter: 'invite-empty-filter',
  dashboardWidget: 'invite-dashboard-widget',
  widgetSignups: 'invite-widget-signups',
  widgetCopyButton: 'invite-widget-copy-button',
  widgetOpenButton: 'invite-widget-open-button',
  registerBanner: 'invite-register-banner',
  navMenuItem: 'invite-nav-menu-item',
  footerLink: 'invite-footer-link',
  adminTab: 'admin-referrals-tab',
  adminTable: 'admin-referrals-table',
};

export const MOBILE_NAV = {
  root: 'mobile-bottom-nav',
  discoverTab: 'mobile-nav-discover-tab',
  talentTab: 'mobile-nav-talent-tab',
  eventsTab: 'mobile-nav-events-tab',
  castingsTab: 'mobile-nav-castings-tab',
  accountTab: 'mobile-nav-account-tab',
  accountSheet: 'mobile-nav-account-sheet',
  sheetLogin: 'mobile-nav-sheet-login',
  sheetRegister: 'mobile-nav-sheet-register',
  sheetDashboard: 'mobile-nav-sheet-dashboard',
  sheetInvite: 'mobile-nav-sheet-invite',
  sheetOnboarding: 'mobile-nav-sheet-onboarding',
  sheetPostCasting: 'mobile-nav-sheet-post-casting',
  sheetPostEvent: 'mobile-nav-sheet-post-event',
  sheetKyc: 'mobile-nav-sheet-kyc',
  sheetPremium: 'mobile-nav-sheet-premium',
  sheetAdmin: 'mobile-nav-sheet-admin',
  sheetLogout: 'mobile-nav-sheet-logout',
  topJoinButton: 'mobile-nav-top-join-button',
  fab: 'mobile-nav-fab',
  fabBackdrop: 'mobile-nav-fab-backdrop',
  fabPostEvent: 'mobile-nav-fab-post-event',
  fabPostCasting: 'mobile-nav-fab-post-casting',
  fabQuickBook: 'mobile-nav-fab-quick-book',
  fabInvite: 'mobile-nav-fab-invite',
  fabSignIn: 'mobile-nav-fab-sign-in',
  fabRegister: 'mobile-nav-fab-register',
};
